import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Alert } from 'antd';
import { AnyObject, Error } from '@triare/auth-redux/dist/saga/common';
import { User } from '@triare/auth-redux/dist/saga/auth/useMe';
import { AlertProps } from 'antd/es/alert';
import { RootState } from '../../../../../../../store';
import { actions, moduleName } from '../../../../../../../store/auth';

export interface AlertSuccessProps extends AlertProps {
  disable?: boolean;
  authorized: boolean;
  response: AnyObject | null;
  error: Error | null;
  user: User | null;
}

function AlertSuccess({
  disable, authorized, user, error, response, ...props
}: AlertSuccessProps): React.ReactNode {
  const dispatch = useDispatch();

  if (disable === false && authorized && user && !error && response) {
    return (
      <Alert
        type="success"
        message="Вход выполнен успешно!"
        closable
        onClose={() => dispatch({
          type: actions.signInClear.type,
        })}
        {...props}
      />
    );
  }

  return null;
}

AlertSuccess.defaultProps = {
  disable: false,
};

export default connect((state: RootState) => ({
  authorized: state[moduleName].authorized,
  response: state[moduleName].signIn.response,
  error: state[moduleName].signIn.error,
  user: state[moduleName].user,
}))(AlertSuccess);
